import { useEffect, useState } from "react";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import { fetchDashboard } from "../model/AssetUpload";

const DashboardVM = ({ active }) => {
  const { handleToastOpen } = useToast();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [days, setDays] = useState(30); // warranty window: 30 / 60 / 90

  const load = async (windowDays = days) => {
    try {
      setLoading(true);
      const response = await fetchDashboard(windowDays);
      setData(response.data?.data || null);
    } catch (error) {
      handleToastOpen(
        "error",
        error.response?.data?.message || "Failed to load the dashboard"
      );
    } finally {
      setLoading(false);
    }
  };

  // Load every time the tab is opened (numbers may have changed)
  useEffect(() => {
    if (active) load();
  }, [active]);

  const handleDaysChange = (value) => {
    setDays(value);
    load(value);
  };

  return { data, loading, days, handleDaysChange, reload: () => load() };
};

export default DashboardVM;